import * as types from './mutation-types'

export const mutations = {
  [types.TOGGLE_MENU](state) {
    state.menu.active = !state.menu.active
  },

  [types.TOGGLE_FOOTER](state) {
    state.footer.active = !state.footer.active
  },

  [types.TOGGLE_SIDEBAR](state, open) {
    if (typeof open === 'boolean') {
      // Open / close
      state.sidebar.active = open
    } else {
      // Toggle
      state.sidebar.active = !state.sidebar.active
    }
  },

  [types.SUPPORTS_SHOW](state, show) {
    state.supports.show = show
  },

  [types.SUPPORTS_TECHNO_AUTRES](state, technologieAutre) {
    state.supports.technologieAutre = technologieAutre
  },

  [types.IGN_LAYER_SET_CURRENT](state, layer) {
    state.ign = layer
  },

  [types.QUESTIONNAIRE_SETDETAILS](state, details) {
    console.log('questionnaire : set')
    state.questionnaire = details
  },

  [types.QUESTIONNAIRE_UNSET](state) {
    console.log('questionnaire : unset')
    state.questionnaire = null
  }
}
